import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  constructor(private readonly sharedModalService: ModalService, public activeModal: NgbActiveModal) {}

  public confirm() {
    this.sharedModalService.yesNoModalClosed.emit(true);
    this.activeModal.close();
  }

  public reject() {
    this.sharedModalService.yesNoModalClosed.emit(false);
    this.activeModal.close();
  }
}
